import callApi from '../../call-api';

const mergeOptions = (options, overrides) =>
  Object.assign({}, options, overrides);

const apiResourceBuilder = options => {
  let idResolver = ({ id }) => id;
  let entityName = options;
  if (typeof options === 'object') {
    entityName = options.name;
    idResolver = options.idResolver;
  } else if (typeof options !== 'string') {
    throw new Error(
      `Unsupported parameter: apiResourceBuilder(options) expected either (object, string); got: ${typeof options}`
    );
  }

  const endpointUrl = id => `/api/${entityName}/${id || ''}`;

  const cleanBody = entity =>
    Object.keys(entity).reduce((acc, key) => {
      const value = entity[key];
      // if undefined skip
      if (typeof value === 'undefined') {
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});

  const entityApiCall = (id, options) => {
    return callApi(endpointUrl(id), options);
  };

  const get = (id, options) => entityApiCall(id, options);

  const post = (entity, options) =>
    entityApiCall(
      null,
      mergeOptions(
        {
          method: 'POST',
          body: JSON.stringify(cleanBody(entity)),
        },
        options
      )
    );

  const put = (entity, options) =>
    entityApiCall(
      idResolver(entity),
      mergeOptions(
        {
          method: 'PUT',
          body: JSON.stringify(cleanBody(entity)),
        },
        options
      )
    );

  const save = (entity, options) =>
    (idResolver(entity) ? put(entity, options) : post(entity, options));

  const del = (id, options) =>
    entityApiCall(
      id,
      mergeOptions(
        {
          method: 'DELETE',
        },
        options
      )
    );

  return {
    options: {
      name: entityName,
      idResolver,
    },
    get,
    post,
    put,
    save,
    delete: del,
  };
};

export default apiResourceBuilder;



// WEBPACK FOOTER //
// ./src/common/utils/apiResourceBuilder/index.js